<template>
    <div class="w100 bgGrey">
        <article class="wContent center">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-row :gutter="20" class="mw-modular-box">
                        <el-col :span="12">
                            <div class="bgWhite textCenter user-title-box" style="min-height: 138px;">
                                <img :src="userInfo.photoUrl ? userInfo.photoUrl : userPhoto" alt="">
                                <p class="font14 fontBold">{{ userName }}</p>
                                <small class="fontLight block">{{ userInfo.enterpriseName }}</small>
                            </div>
                            <router-link :to="'/home/quoteDetail?id=' + userInfo.phone" class="fontWhite"><el-button type="danger" class="w100" style="margin-top: 20px;">进入报价</el-button></router-link>
                            
                        </el-col>
                        <el-col :span="12">
                            <div class="bgWhite textCenter user-concat-box">
                                <div class="user-concat-top textCenter">专属客服</div>
                                <p class="fontNormal fontBold">已为您定制专属客服</p>
                                <p class="fontLight">24小时无休提供服务</p>
                                <img class="user-concat-avator" src="../../assets/images/self_2.png" alt="">
                                <p class="user-concat-phone">400-6565-958</p>
                            </div>
                            <router-link :to="'/home/tradeDetail?id=' + userInfo.phone" class="fontWhite">
                                <el-button type="danger" class="w100" style="margin-top: 20px;">进入商情</el-button>
                            </router-link>
                            
                        </el-col>
                    </el-row>

                    <!-- <ModifyPriceControl :ad="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adPicturePath'] : '') : ''" :link="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adLink'] : '') : ''"></ModifyPriceControl> -->

                    <HotRecord class="mw-modular-box" :ad="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adPicturePath'] : '') : ''" :link="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adLink'] : '') : ''"></HotRecord>
                    
                </el-col>
                <el-col :span="16">
                    <div class="bgWhite mw-modular-box">
                        <ul class="user-info-menu-box">
                            <li><a href="javascript:;" @click="tabChange(6)" class="user-info-menu font14 textCenter block" :class="{active: cTab == 6}">发布报价/商情</a></li>
                            <li><a href="javascript:;" @click="tabChange(1)" class="user-info-menu font14 textCenter block" :class="{active: cTab == 1}">我的收藏</a></li>
                            <!-- <li><a href="javascript:;" @click="tabChange(2)" class="user-info-menu font14 textCenter block" :class="{active: cTab == 2}">钢厂调价定制</a></li> -->
                            <li><a href="javascript:;" @click="tabChange(3)" class="user-info-menu font14 textCenter block" :class="{active: cTab == 3}">基本资料</a></li>
                            <li><a href="javascript:;" @click="tabChange(4)" class="user-info-menu font14 textCenter block" :class="{active: cTab == 4}">修改密码</a></li>
                            <li><a href="javascript:;" @click="tabChange(5)" class="user-info-menu font14 textCenter block" :class="{active: cTab == 5}">修改手机</a></li>
                        </ul>
                        <div class="clear"></div>
                    </div>

                    <div class="bgWhite mw-modular-box p20" style="min-height: 1130px;">
                        <div v-show="cTab == 1">
                            <div v-show="hasCollection"
                                v-loading="inforLoading"
                                element-loading-text="拼命加载中"
                                element-loading-spinner="el-icon-loading"
                                element-loading-background="rgba(255, 255, 255, 1)"
                            >

                                <ul class="user-info-collect-box">
                                    <li v-for="(item, index) in inforTab_list" :key="index"><a href="javascript:;" @click="collectTypeChange(item)" class="user-info-collect font14 textCenter block" :class="{active: collectType == item.consult_id}">{{ item.type_name }}</a></li>
                                </ul>
                                <div class="clear"></div>
                                <div class="part-tab-collect" v-show="infor_data.length > 0">
                                    <div v-for="(item, index) in infor_data" :key="index">
                                        <div class="part-tab-clist pointer" v-show="item.img" @click="goDetailPage(item.primary_id)">
                                            <span class="tag">{{ item.type_name }}</span>
                                            <div style="flex: 1;"> <img :src="'data:image/jpeg;base64,' + item.img" alt="" srcset=""> </div>
                                            <div style="flex: 4;" class="w100 textLeft main">
                                                <h4 class="font16 fontBold fontNormal">{{ item.the_title }}</h4>
                                                <div class="main-sub fontLight">{{ item.overview }}</div>
                                                <div class="main-tags-box">
                                                    <span v-if="item.the_table">
                                                        <span v-for="(table, tableI) in item.the_table.split(',')" :key="tableI" style="margin-right: 5px;" class="inlineBlock">
                                                            <span class="main-tag fontRed" v-if="table">{{ table }}</span>
                                                        </span>
                                                    </span>
                                                    <span v-if="item.the_table">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                                    <span>{{ item.oper_man ? item.oper_man : '未知' }}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                                    <span>{{ compareTime(item.create_date) }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="part-tab-clist pointer" v-show="!item.img" @click="goDetailPage(item.primary_id)" style="border-bottom: 1px solid #eee;">
                                            <span class="tag">{{ item.type_name }}</span>
                                            <div class="w100 textLeft main" style="padding-left: 10px">
                                                <h4 class="font16 fontBold fontNormal" style="margin-left: 70px">{{ item.the_title }}</h4>
                                                <div class="main-sub fontLight">{{ item.overview }}</div>
                                                <div class="main-tags-box">
                                                    <span v-if="item.the_table">
                                                        <span v-for="(table, tableI) in item.the_table.split(',')" :key="tableI" style="margin-right: 5px;" class="inlineBlock">
                                                            <span class="main-tag fontRed" v-if="table">{{ table }}</span>
                                                        </span>
                                                    </span>
                                                    <span v-if="item.the_table">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                                    <span>{{ item.oper_man ? item.oper_man : '未知' }}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                                    <span>{{ compareTime(item.create_date) }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="infor_data.length == 0" class="mw-modular-box textCenter font14">暂无收藏~</div>
                                <!-- <div class="textCenter" style="padding-top: 30px">
                                    <el-button class="load-more-btn" @click="loadMore()">+ 加载更多</el-button>
                                </div> -->
                            </div>
                            <div v-show="!hasCollection" class="textCenter font16">还没有收藏文章，快去收藏吧~</div>
                        </div>

                        <div v-show="cTab == 2">
                            <div class="cus-box" style="height: 1110px; overflow-y: auto; overflow-x: hidden;">
                                <h4 class="font14">已定制的品种</h4>
                                <hr style="border: 0; border-top: 1px solid #eee; margin: 10px 0 40px 0;">

                                <el-row>
                                    <el-col :span="6">&nbsp;</el-col>
                                    <el-col :span="18">
                                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAll" style="margin-bottom: 10px; margin-left: 15px">全选</el-checkbox>
                                    </el-col>
                                </el-row>
                                <div v-for="(item, index) in list_data" :key="index">
                                    <el-row :gutter="15">
                                        <el-col :span="6">
                                            <div class="textRight font14">
                                                {{ item.productName }} :
                                            </div>
                                        </el-col>
                                        <el-col :span="18">
                                            <div class="check-box radius">
                                                <el-checkbox-group v-model="personalCheckOptions" @change="handleCheckSingle">
                                                    <el-checkbox 
                                                    v-for="(cItem, cIndex) in item.childList" 
                                                    :key="cIndex" 
                                                    :label="cItem.productId" 
                                                    @change="checkProduct(item, index, cItem, cIndex)"
                                                    style="margin-bottom: 10px"
                                                    >
                                                    {{ cItem.productName }}
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div class="textCenter">
                                    <el-button type="danger" :loading="loading" class="dz-submit bgRed" @click="submit">提 交</el-button>
                                </div>
                            </div>
                        </div>

                        <div v-show="cTab == 3" class="ctab-3">
                            <h4 class="font14 p10">个人资料</h4>
                            <el-form :model="userInfo" label-width="150px">
                                <el-form-item label="公司名称">
                                    <span>{{ userInfo.enterpriseName }}</span>
                                </el-form-item>
                                <el-form-item label="手机号">
                                    <span>{{ userInfo.phone }}</span>
                                </el-form-item>
                                <el-form-item label="会员名称">
                                    <el-input v-model="userInfo.username"></el-input>
                                </el-form-item>
                                
                                <!-- <el-form-item label="企业类型">
                                    <div class="check-box radius">
                                        <el-checkbox-group v-model="enterpriseType" @change="checkEnterprise">
                                            <el-checkbox :label="item.typeId" v-for="(item, index) in enterpriseType_data" :key="index">{{ item.typeName }}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </el-form-item>
                                <el-form-item label="关注品种">
                                    <div class="check-box radius">
                                        <el-checkbox-group v-model="focusProduct" @change="checkProduct">
                                            <el-checkbox :label="item.navigationId" v-for="(item, index) in focusProduct_data" :key="index">{{ item.navigationName }}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </el-form-item> -->
                                <el-form-item>
                                    <el-button class="bgRed fontWhite" @click="onSubmit()" size="medium" style="width: 100px" :loading="submitLoading">提 交</el-button>
                                </el-form-item>
                            </el-form>
                        </div>

                        <div v-show="cTab == 4" class="cTab-4 center textCenter">
                            <p class="fontLighter font14">*为了您的账号安全，请先进行身份验证</p>
                            <p class="fontRed font14" style="margin-top: 5px;">*若无手机号，请联系客服</p>
                            <p class="font16 textLeft" style="margin-top: 20px">使用手机 {{ userInfo.phone }} 验证</p>

                            <el-form :model="userInfo">
                                <el-form-item>
                                    <el-input clearable type="password" v-model="userInfo.password" auto-complete="off" placeholder="请设置新密码" style="margin-bottom: 10px;" class="w100"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <div class="check-code textLeft">
                                        <span class="inlineBlock vMid">验证码：</span>
                                        <div class="code-before textCenter inlineBlock vMid" id="vContainer"></div>
                                        <input type="text" class="code-after inlineBlock vMid" v-model="verification">
                                        <span class="fontRed pointer" @click="changeV(1)">看不清，换一个</span>
                                    </div>
                                </el-form-item>
                                <el-form-item>
                                    <el-input clearable v-model="code" auto-complete="off" placeholder="请输入验证码" class="w100">
                                        <template slot="append">
                                            <span v-show="sendCodeTime == 0" @click="sendCode" class="pointer">发送验证码</span>
                                            <span v-show="sendCodeTime != 0">({{ sendCodeTime }})秒后重新发送</span>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </el-form>
                            <div slot="footer" class="dialog-footer" style="margin-top: 50px; padding-bottom: 30px">
                                <el-button class="bgRed w100 fontWhite" @click="changePassWord()" size="medium" :loading="passwordLoading">保 存</el-button>
                            </div>
                        </div>

                        <div v-show="cTab == 5" class="cTab-5 center textCenter">
                            <p class="font16 textLeft mw-modular-box">当前账号： {{ phone }} </p>

                            <el-form :model="userInfo">
                                <el-form-item>
                                    <el-input clearable type="text" v-model="userInfo.phone" auto-complete="off" placeholder="请设置新手机号" style="margin-bottom: 10px;" class="w100"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <div class="check-code textLeft">
                                        <span class="inlineBlock vMid">验证码：</span>
                                        <div class="code-before textCenter inlineBlock vMid" id="vContainer2"></div>
                                        <input type="text" class="code-after inlineBlock vMid" v-model="verification2">
                                        <span class="fontRed pointer" @click="changeV(2)">看不清，换一个</span>
                                    </div>
                                </el-form-item>
                                <el-form-item>
                                    <el-input clearable v-model="code_1" auto-complete="off" placeholder="请输入验证码" class="w100">
                                        <template slot="append">
                                            <span v-show="sendCodeTime_1 == 0" @click="sendCode1" class="pointer">发送验证码</span>
                                            <span v-show="sendCodeTime_1 != 0">({{ sendCodeTime_1 }})秒后重新发送</span>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </el-form>
                            <div slot="footer" class="dialog-footer" style="margin-top: 50px; padding-bottom: 30px">
                                <el-button class="bgRed w100 fontWhite" @click="changeTelephone()" size="medium" :loading="telephoneLoading">保 存</el-button>
                            </div>
                        </div>

                        <div v-show="cTab == 6" class="">
                            <QuoteControl></QuoteControl>
                        </div>
                    </div>
                </el-col>

            </el-row>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import HotRecord from '../../templates/hotRecord'
import ModifyPriceControl from '../../templates/modifyPriceControl'
import ConcatsControl from '../../templates/concatsControl'
import QuoteControl from '../../templates/quoteControl'
import $ from 'jquery'
import '../../assets/js/gVerify'
import { baseUrl, adIDs } from '../../assets/js/common'
export default {
    name: 'SelfPage',
    components: { HotRecord, ModifyPriceControl, ConcatsControl, QuoteControl },
    data () {
        return {
            adIDsIndex: [],
            userPhoto: require('../../assets/images/user.jpg'),
            cTab: 6,
            collectType: 1,
            collectName: '',
            inforTab_list: [],
            infor_data: [],
            hasCollection: true,
            inforLoading: false,

            userInfo: {},
            userName: '',
            phone: '',
            list_data: [],
            personalCheckOptions: [],

            enterpriseType: [],
            enterpriseType_data: [],
            focusProduct: [],
            focusProduct_data: [],

            checkAll: false,
            isIndeterminate: false,

            loading: false,

            code: '',
            code_1: '',
            sendCodeTime: 0,
            passwordLoading: false,
            sendCodeTime_1: 0,
            telephoneLoading: false,
            submitLoading: false,

            verification: '',
            verifyCode: null,
            verification2: '',
            verifyCode2: null
        }
    },
    mounted () {
        // 初始化内容
        this.getUserInfoAll();
        this.getAdByAdp();
    },
    methods: {
        //页面操作
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex = [{
                name: 'indexRight1',
                id: adIDs['indexRight1'],
                list: []
            }, {
                name: 'indexRight2',
                id: adIDs['indexRight2'],
                list: []
            }];
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },
        // 切换
        tabChange (type) {
            this.cTab = type;
            // this.getUserInfoAll(); // 切换tab时 重新获取一次
            if (type == 4) {
                this.verification = '';
                this.verifyCode = new GVerify({ id: 'vContainer', canvasId: 'verifyCanvas'});
            }
            if (type == 5) {
                this.verification2 = '';
                this.verifyCode2 = new GVerify({ id: 'vContainer2',canvasId: 'verifyCanvas2'});
            }
        },
        changeV (type) {
            if (type == 1) {
                this.verification = '';
                this.verifyCode.refresh();
            } else {
                this.verification2 = '';
                this.verifyCode2.refresh();
            }
        },
        collectTypeChange (item) {
            self.inforLoading = true;
            this.collectType = item.consult_id;
            this.collectName = item.type_name;
            this.infor_data = [];
            this.findInforIds();
        },

        // 根据userInfo 获取用户全部信息
        getUserInfoAll () {
            const self = this;
            const token_cyw = self.$cookies.get('token_cyw');
            if (token_cyw) {
                self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        self.$get(`${baseUrl.business}/api/user/find/${res_1.data.id}`, {}).then(res => {
                            if (res.status == 200) {
                                self.userInfo = res.data;
                                self.userName = res.data.username;
                                self.phone = res.data.phone;
                                // const _userInfo = $.extend(true, [], self.userInfo);
                                // console.log(_userInfo.enterpriseType)
                                // if (_userInfo.focusProduct) {
                                //     _userInfo.focusProduct = _userInfo.focusProduct.indexOf(',') == 0 ? _userInfo.focusProduct.substr(1, _userInfo.focusProduct.length) : _userInfo.focusProduct;
                                // }
                                // if (_userInfo.enterpriseType) {
                                //     _userInfo.enterpriseType = _userInfo.enterpriseType.indexOf(',') == 0 ? _userInfo.enterpriseType.substr(1, _userInfo.enterpriseType.length) : _userInfo.enterpriseType;
                                // }
                                // self.enterpriseType = _userInfo.enterpriseType ? JSON.parse('[' + _userInfo.enterpriseType + ']') : []; //self.userInfo.enterpriseType.split(',');
                                // self.focusProduct = _userInfo.focusProduct ? JSON.parse('[' + _userInfo.focusProduct + ']') : [];
                                // self.userName = _userInfo.username;
                                // self.phone = _userInfo.phone;
                                // self.getProductTreeList();
                                // self.getPersonalProduct();
                                // self.getEnterpriseType();
                                // self.getFocusProduct();
                                self.findInforTypeIds();
                            } else {
                                self.$confirm('未获取到此用户信息', '提示', {
                                    confirmButtonText: '确定',
                                    showCancelButton: false,
                                    type: 'error'
                                }).then(() => {
                                    self.$router.push('/index')
                                })
                            }
                        })
                    } else {
                        self.$confirm(res_1.msg, '提示', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            type: 'error'
                        }).then(() => {
                            self.$router.push('/index')
                        })
                    }
                }).catch(err_1 => {
                    self.$confirm('未获取到此用户信息', '提示', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        type: 'error'
                    }).then(() => {
                        self.$router.push('/index')
                    })
                })
            } else {
                self.$confirm('请先登录', '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    type: 'warning'
                }).then(() => {
                    self.$router.push('/index')
                })
            }
        },

/* ****************************** 获取我的收藏 *********************************** */
        findInforTypeIds () {
            const self = this;
            self.inforLoading = true;
            self.$get(`${baseUrl.cyw}/inforUser/findInforTypeIds?userId=${self.userInfo.id}`, {}).then(res => {
                if (res.code == 0) {
                    // 根据id们 获取分类信息
                    if (res.data.length > 0) {
                        self.hasCollection = true;
                        res.data = res.data.indexOf(null) > -1 ? res.data.splice(res.data.indexOf(null) + 1, res.data.length) : res.data;
                        $.ajax({
                            url: `${baseUrl.service}/api_v3/new_consult_sel_id?consult_id=${res.data.join(',')}`,
                            data: {},
                            type: 'get',
                            dataType: 'json',
                            success: (res_2) => {
                                if (res_2.code == 'ok') {
                                    if (res_2.data.length > 0) {
                                        self.inforTab_list = res_2.data;
                                        self.collectType = res_2.data[0]['consult_id'];
                                        self.collectName = res_2.data[0]['type_name'];
                                        self.findInforIds();
                                    } else {
                                        self.inforLoading = false;
                                    }
                                } else {
                                    self.$message.error(res_2.message);
                                    self.inforLoading = false;
                                }
                            },
                            error: () => {
                                // self.$message.error('未获取到资讯分类信息')
                                self.inforLoading = false;
                            }
                        })
                    } else {
                        self.hasCollection = false;
                        self.inforLoading = false;
                    }
                } else {
                    // self.$message.error(res.message);
                    self.hasCollection = false;
                    self.inforLoading = false;
                }
            })
        },
        findInforIds () {
            const self = this;
            self.$get(`${baseUrl.cyw}/inforUser/findInforIds?userId=${self.userInfo.id}&typeId=${self.collectType}`, {}).then(res => {
                if (res.code == 0) {
                    // 根据id们 获取资讯信息
                    $.ajax({
                        url: `${baseUrl.service}/api_v3/t_news_consult_sel_p_id?primary_id=${res.data.join(',')}`,
                        data: {},
                        type: 'get',
                        dataType: 'json',
                        success: (res_2) => {
                            if (res_2.code == 'ok') {
                                self.infor_data = res_2.data;
                                res_2.data.forEach((item, index) => {
                                    self.getPrimaryInfos(item.primary_id, index);
                                })
                                if (res_2.data.length == 0) {
                                    self.inforLoading = false;
                                }
                            } else {
                                self.$message.error(res_2.message);
                                self.inforLoading = false;
                            }
                        },
                        error: () => {
                            // self.$message.error('未获取到资讯信息')
                            self.inforLoading = false;
                        }
                    })
                }
            })
        },
        // 获取信息
        getPrimaryInfos (id, index) {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/t_graphic_sel/${id}`,
                data: {},
                type: 'get',
                async: false,
                dataType: 'json',
                success: (res) => {
                    if (res.code == 'ok') {
                        self.infor_data[index]['img'] =  res.data.base_file;
                        if (index == self.infor_data.length - 1) {
                            self.$set(self.infor_data, self.infor_data)
                            self.inforLoading = false;
                        }
                    } else {
                        self.infor_data[index]['img'] = '';
                        if (index == self.infor_data.length - 1) {
                            self.$set(self.infor_data, self.infor_data)
                            self.inforLoading = false;
                        }
                    }
                },
                error: () => {
                    self.infor_data[index]['img'] = '';
                    if (index == self.infor_data.length - 1) {
                        self.$set(self.infor_data, self.infor_data)
                        self.inforLoading = false;
                    }
                }
            })
        },
        goDetailPage (id) {
            this.$router.push(`/home/inforDetail/${id}`)
        },
/* ****************************** 获取我的收藏 *********************************** */
       

/* ****************************** 获取企业类型和品种 ****************************** */

        // 获取完善信息 - 企业类型
        getEnterpriseType () { 
            const self = this;
            self.$get(`${baseUrl.crm}/business/cyw/openapi/getEnterpriseType.json`, {}).then(res => {
                if (res.code == 200) {
                    self.enterpriseType_data = res.data;
                } else {
                    self.$message.error('获取企业类型失败');
                }
            })
        },
        // 获取完善信息 - 企业类型
        getFocusProduct () {
            const self = this;
            self.$get(`${baseUrl.cyw}/navigation/selectNa?level=2`, {}).then(res => {
                if (res.code == 0) {
                    self.focusProduct_data = res.data;
                } else {
                    self.$message.error('获取关注品种失败');
                }
            })
        },

        // 选择关注的产品
        checkProduct (ids) {
            this.focusProduct = [].slice.call(ids);
        },
        // 选择企业类型
        checkEnterprise (ids) {
            this.enterpriseType = [].slice.call(ids);
        },

/* ****************************** 获取企业类型和品种 ****************************** */


/* ****************************** 我的定制 *************************************** */
        // 获取全部品类信息
        getProductTreeList () {
            const self = this;
            self.$get(`${baseUrl.crm}/business/cyw/openapi/getProductTreeList.json`, {}).then(res => {
                if (res.code == 200) {
                    self.list_data = res.data;
                    console.log(self.list_data)
                } else {
                    self.$message.error('信息获取失败')
                }
            })
        },

        // 获取当前用户已定制的产品
        getPersonalProduct () {
            const self = this;
            console.log(self.userInfo)
            self.$get(`${baseUrl.crm}/business/cyw/openapi/getSignTreeList.json/${self.userInfo.id}`, {}).then(res => {
                if (res.code == 200) {
                    if (res.data.length == 0) {
                        // self.$message({
                        //     message: '暂无定制信息',
                        //     type: 'warning'
                        // })
                    } else {
                        $.each(res.data, (index, item) => {
                            $.each(item['childList'], (cIndex, cItem) => {
                                self.personalCheckOptions.push(cItem.productId);
                            })
                        })
                    }
                } else {
                    self.$message.error('信息获取失败')
                }
            })
        },

        handleCheckSingle (checks) {
            const newArr = checks.filter(Boolean);
            this.personalCheckOptions = newArr;
            this.checkAll = checks.length === this.list_data.length;
            this.isIndeterminate = checks.length > 0 && checks.length < this.list_data.length;
        },

        handleCheckAll (val) {
            const self = this;
            let checkIds = [];
            self.isIndeterminate = false;
            if (val) {
                $.each(self.list_data, (index, item) => {
                    if (item['childList']) {
                        $.each(item['childList'], (cIndex, cItem) => {
                            checkIds.push(cItem['productId'])
                        })
                    }
                })
            }
            self.personalCheckOptions = checkIds;
        },

        // 提交数据
        submit () {
            const self = this;
            // if (self.personalCheckOptions.length == 0) {
            //     self.$message({
            //         message: '请选择定制品种',
            //         type: 'warning'
            //     })
            // } else {
                self.loading = true;
                const priceCustom = self.personalCheckOptions.length > 0 ? self.personalCheckOptions.join(',') : '';
                self.$post(`${baseUrl.crm}/business/cyw/openapi/updateCYWUser.json`, {crmUserId: self.userInfo.i, priceCustom: priceCustom}).then(res => {
                    if (res.code == 200) {
                        self.$message('您已成功定制');
                        // self.getUserInfoAll();
                        self.$router.go(0)
                    } else {
                        self.$message.error('定制失败，请重试');
                    }
                    self.loading = false;
                })
            // }
        },
/* **************************************** 我的定制 ***************************** */


/* ****************************** 修改基础资料 ************************************ */

        onSubmit() {
            const self = this;
            self.$confirm('确认修改吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                self.submitLoading = true;
                // const obj = {
                //     username: self.userInfo.username,
                //     crmUserId: self.userInfo.i,
                //     enterpriseType: self.enterpriseType.join(','),
                //     focusProduct: self.focusProduct.join(','),
                //     priceCustom: self.userInfo.priceCustom
                // }
                const obj = {
                    id: self.userInfo.id,
                    username: self.userInfo.username,
                    phone: self.userInfo.phone,
                    // password: self.userInfo.username,
                    enterpriseName: self.userInfo.enterpriseName
                }
                self.$put(`${baseUrl.business}/api/user/update`, obj).then(res => {
                    if (res.status == 200) {
                        self.$message('保存成功')
                        self.submitLoading = false;
                        setTimeout(() => {
                            this.$router.go(0);
                        }, 200)
                    } else {
                        self.$message.error(res.msg);
                        self.submitLoading = false;

                    }
                }).catch(err => {
                    self.$message.error('保存失败');
                    self.submitLoading = false;
                })
            })
        },


/* ****************************** 修改基础资料 ************************************ */


/* ******************************* 修改密码 ***************************************** */
        // 发送验证码
        sendCode () {
            const self = this;
            self.sendCodeTime = 60;
            let interval = setInterval(() => {
                if (self.sendCodeTime == 0) {
                    clearInterval(interval);
                } else {
                    if (self.sendCodeTime == 60) {
                        // 发送手机验证码
                        self.$get(`${baseUrl.sso}/api/sendCode?telephone=${self.userInfo.phone}`, {}).then(res => {
                            if (res.code == 200) {
                                // self.code = res.data;
                                this.$message('验证码已发送');
                            } else {
                                self.codeErrMsg(res.code);
                                self.sendCodeTime = 0;
                            }
                        }).catch(err => {
                            self.registarLoading = false;
                            self.$message.error('验证码发送失败');
                            self.sendCodeTime = 0;
                        })
                    }
                    self.sendCodeTime--;
                }
            }, 1000)
        },

        changePassWord () {
            const self = this;
            if (!self.verifyCode.validate(self.verification)) {
                self.$message({
                    message: '验证码错误',
                    type: 'warning'
                })
                return;
            }
            if (self.userInfo.password) {
                // 进行验证码验证
                self.passwordLoading = true;
                self.checkCode('pwd')
            } else {
                self.$message({
                    message: '请输入新的密码',
                    type: 'warning'
                })
            }
        },
        
        // 密码修改提交
        onSubmitPwd () {
            const self = this;
            self.$postByX(`${baseUrl.business}/api/user/updatePwd?telephone=${self.userInfo.phone}&newPwd=${self.userInfo.password}`, {}).then(res => {
                if (res.status == 200) {
                    self.$message('修改成功');
                    self.verification = '';
                    self.sendCodeTime = 0;
                    self.code = '';
                    // self.getUserInfoAll()
                    this.$router.go(0); 
                } else {
                    self.$message.error(res.msg)
                }
                self.passwordLoading = false;
            }).catch(err => {
                self.$message.error('调用异常');
                self.passwordLoading = false;
            })
        },

/* ******************************* 修改密码 ***************************************** */

/* ******************************** 修改手机号 ****************************************** */
        sendCode1 () {
            const self = this;
            self.sendCodeTime_1 = 60;
            let interval = setInterval(() => {
                if (self.sendCodeTime_1 == 0) {
                    clearInterval(interval);
                } else {
                    if (self.sendCodeTime_1 == 60) {
                        // 发送手机验证码
                        self.$get(`${baseUrl.sso}/api/sendCode?telephone=${self.userInfo.phone}`, {}).then(res => {
                            if (res.code == 200) {
                                // self.code_1 = res.data;
                                this.$message('验证码已发送');
                            } else {
                                self.codeErrMsg(res.code);
                                self.sendCodeTime_1 = 0;
                            }
                        }).catch(err => {
                            self.registarLoading = false;
                            self.$message.error('验证码发送失败');
                            self.sendCodeTime_1 = 0;
                        })
                    }
                    self.sendCodeTime_1--;
                }
            }, 1000)
        },

        changeTelephone () {
            const self = this;
            if (!self.verifyCode2.validate(self.verification2)) {
                self.$message({
                    message: '验证码错误',
                    type: 'warning'
                })
                return;
            }
            if (self.userInfo.phone) {
                // 进行验证码验证
                self.telephoneLoading = true;
                self.checkCode('phone')
            } else {
                self.$message({
                    message: '请输入新的手机号',
                    type: 'warning'
                })
            }
        },

        onSubmitPhone () {
            const self = this;
            self.$postByX(`${baseUrl.business}/api/user/updateTel?telephone=${self.phone}&newTel=${self.userInfo.phone}`, {}).then(res => {
                if (res.status == 200) {
                    self.$message('修改成功');
                    self.verification2 = '';
                    self.sendCodeTime_1 = 0;
                    self.code_1 = '';
                    // self.getUserInfoAll()
                    setTimeout(() => {
                        this.$router.go(0); 
                    }, 200)
                } else {
                    self.$message.error(res.msg);
                }
                self.telephoneLoading = false;
            }).catch(err => {
                self.$message.error('调用异常');
                self.telephoneLoading = false;
            })
        },
/* ******************************** 修改手机号 ****************************************** */

        // 验证验证码
        checkCode (type) {
            let self = this;
            // step1. 验证 验证码是否有效
            // self.$get(`${baseUrl.sso}/api/checkCodeIsValid?telephone=${self.userInfo.phone}`, {}).then(res => {
            //     if (res.code == 200) {
            //         self.$postByX(`${baseUrl.sso}/api/checkCodeIsTrue?telephone=${self.userInfo.phone}&code=${type == 'pwd' ? self.code : self.code_1}`, {}).then(res_2 => {
            //             if (res_2.code == 200) {
                            // 验证成功，提交数据
                            if (type == 'pwd') {
                                self.onSubmitPwd();
                            } else {
                                self.onSubmitPhone();
                            }
            //             } else {
            //                 self.codeErrMsg(res_2.code);
            //             }
            //         })
            //     } else {
            //         self.codeErrMsg(res.code);
            //     }
            // }) 
        },

        // 验证码错误提示
        codeErrMsg (rescode) {
            console.log(rescode)
            let self = this;
            let msg = '';
            switch (rescode) {
                case 300:
                    msg = '手机号不能为空';
                    break;
                case 500:
                    msg = '操作失败';
                    break;
                case 109:
                    msg = '手机号格式不正确';
                    break;
                case 111:
                    msg = '验证码发送失败，请再次尝试';
                    break;
                case 112:
                    msg = '验证码还在有效期';
                    break;
                case 113:
                    msg = '验证码已失效，请重新发送';
                    break;
                default:
                    msg = '验证码发送失败';
            }
            self.passwordLoading = false;
            self.telephoneLoading = false;
            self.$message.error(msg);
        },

/* ************************** 获取我的调价信息 ****************** */
/* ************************** 获取我的调价信息 ****************** */

 // 判断时间
        compareTime (date) {
            const time = new Date().getTime();
            const time_1 = new Date(date).getTime();
            const range = time - time_1;
            let time_2;
            let type = 'time';
            if (range <= 1800000) {
                time_2 = Math.floor(range / 60 / 1000);
                // time_2 += '分钟前'
                time_2 = time_2 < 0 ? '刚刚' : time_2 + '分钟前'
            } else if (range < 21600000 && range > 1800000) {
                if (range >= 3600000) {
                    time_2 = Math.floor(range / 60 / 60 / 1000);
                    time_2 += '小时前'
                } else {
                    time_2 = Math.floor(range / 60 / 1000);
                    time_2 += '分钟前'
                }
            } else if (range > 21600000) {
                const newDate = new Date(date);
                time_2 = newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
                type = 'date'
            }
            return time_2
        },





    },
}
</script>

<style scoped>
    @import url('selfPage.css');
</style>